module.exports = __webpack_public_path__ + "img/企業智庫會員.90b2e204.svg";